import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { useCopyToClipboard } from '../hooks/useCopyClipBoard';

export const CopyToClipboard: FunctionComponent<{ text: string }> = ({ text }) => {
  const [copyMessage, copyEvent] = useCopyToClipboard({ text });
  return <Copy onClick={copyEvent}>{copyMessage}</Copy>;
};
const Copy = styled.div``;
